import React, { FC, useMemo } from 'react';
import { Stack, VStack } from '@chakra-ui/react';

import { Country, useFilterListingContextProvider } from '../../context/FilterListingContext';

import ConditionalFragment from '@/components/common/ConditionalFragment';
import CustomRadio from './CustomRadio';
import BuyPageFilterModal from './BuyPageFilterModal';
import { BuyFilterAreaModalProps } from './BuyFilterAreaModalTypes';
import classNames from 'classnames';
import { useAsync } from 'react-use';
import { locationData } from '@/lib/constant';
import { isNotEmptyArray } from '@/utils/formatChecker';
import { cloneWith } from 'lodash';
import CityOptions, { CitySectionOptions } from '@/src/components/feature/CityOptions';

const BuyFilterAreaModal: FC<BuyFilterAreaModalProps> = ({ citiesData, usCitiesData, onClose }) => {
  const { value: location } = useAsync(() => locationData, []);

  const { areaFilterResult, onCountrySelect, onCitySelect, resetAreaFilterResult, setAreaFilterResult } =
    useFilterListingContextProvider();
  const { country } = areaFilterResult;

  const hasUSCities = usCitiesData.length > 0;

  const hasTWItem = useMemo(() => {
    return isNotEmptyArray(citiesData);
  }, [citiesData]);
  const hasUSItem = useMemo(() => {
    return isNotEmptyArray(usCitiesData);
  }, []);

  const countryOptions = useMemo<Array<Option<Country>>>(() => {
    return [
      { value: 'ALL' as Country, label: '全部區域', active: true },
      { value: 'TW' as Country, label: '台灣', active: hasTWItem },
      { value: 'US' as Country, label: '美國', active: hasUSItem },
    ].filter((option) => option.active);
  }, [hasTWItem, hasUSItem]);

  return (
    <BuyPageFilterModal onClose={onClose} onReset={resetAreaFilterResult}>
      <div className={classNames('-mx-6 md:mb-4 w-screen md:w-full', 'flex flex-col flex-1 overflow-hidden')}>
        <VStack w={'full'}>
          <CustomRadio
            disableDesktopExtraStyle
            activeIdx={country}
            onChange={onCountrySelect}
            defaultIdx={0}
            options={countryOptions}
          />
        </VStack>
        <ConditionalFragment condition={country === 'TW' || (country === 'US' && hasUSCities)}>
          <Stack bgColor={'gray.200'} w={'full'} h={'1px'} my={{ md: '4' }} className={'px-6 flex-shrink-0'} />
        </ConditionalFragment>
        <div className={classNames('px-4 w-screen md:w-full', 'relative flex flex-col overflow-scroll')}>
          {country === 'TW' && (
            <CityOptions data={citiesData} cities={areaFilterResult.cities} onCitySelect={onCitySelect} />
          )}
          {country === 'US' && (
            <CitySectionOptions
              data={usCitiesData}
              location={location?.US}
              cities={areaFilterResult.cities}
              onCitySelect={onCitySelect}
              setFilteredCities={
                ((callback: (prev: Array<string>) => Array<string>) => {
                  setAreaFilterResult((prev) => {
                    const cloned = cloneWith(prev);
                    cloned.cities = callback(cloned.cities);
                    return cloned;
                  });
                }) as React.Dispatch<React.SetStateAction<Array<string>>>
              }
            />
          )}
        </div>
      </div>
    </BuyPageFilterModal>
  );
};
export default BuyFilterAreaModal;
